import { render, staticRenderFns } from "./WidgetHost.vue?vue&type=template&id=44a03c96&scoped=true"
import script from "./WidgetHost.vue?vue&type=script&lang=js"
export * from "./WidgetHost.vue?vue&type=script&lang=js"
import style0 from "./WidgetHost.vue?vue&type=style&index=0&id=44a03c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a03c96",
  null
  
)

export default component.exports